<template>
  <div class="conversation-sentiment p-2">
    <div :id="`conversationSentimentGraph-${conversationId}`"></div>
  </div>
</template>

<script>
/* eslint-disable */
import { EventBus } from "@/events/eventBus";

export default {
  name: "ConversationSentiment",
  props: {
    conversationId: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
    };
  },
  computed: {
  },
  created() {
    EventBus.$on("update-sentiment-score", (data) => {
      const { isNew, data: sentimentScore, conversationId } = data;
      if (conversationId === this.conversationId) {
        this.$emit("updated");
      }
    });
  },
  methods: {
  },
};
</script>

<style lang="scss">
.conversation-sentiment {
  width: 100%;
  min-height: 400px;
  .apexcharts-theme-dark,
  .apexcharts-theme-light {
    >svg.apexcharts-svg {
      background: transparent !important;
    };
  }
}
</style>
